module.exports = __webpack_public_path__ + "img/img2.e54d9a98.jpg";